import { thunk } from 'easy-peasy';

import api from '~/services/api';
import { IThunkUpdateMedicaidPlan } from '../types';

const onUpdateMedicaidPlan: IThunkUpdateMedicaidPlan = thunk(
  async ({ setMedicaidPlan }, { requestInfo, requestPayload }) => {
    const { data } = await api.medicaidPlan.updateMedicaidPlan(requestInfo, requestPayload);
    setMedicaidPlan(data);
    return data;
  },
);

export default onUpdateMedicaidPlan;
